import XBAccordion from './XBAccordion';

export default XBAccordion;
